import {
  elementsConfig,
  inputConfig,
  InputType,
  DialogProperty,
} from 'src/app/shared/components/common-dialog/Model/dialog-poperty';
import { DropdownConfig } from 'src/app/shared/components/common-dialog/configs';
import { AppointmentComponent } from '../appointment/appointment.component';

export class DietPlanData {
  public static HEADERS = [
    { id: 'edit', label: '' },
    { id: 'appointment', label: 'Appointment' },
    { id: 'firstName', label: 'Name' },
    { id: 'email', label: 'Email ID' },
    { id: 'phoneNumber', label: 'Phone' },
    { id: 'status', label: 'Status' },
    { id: 'dietPlan', label: 'Diet Plan' },
    { id: 'package', label: 'Package Type' },
    { id: 'packageAmnt', label: 'Package Amount' },
    { id: 'packageStartDate', label: 'Package Start Date' },
    { id: 'packageEndDate', label: 'Package End Date' },
    { id: 'amntReceived', label: 'Amount Received' },
    { id: 'amntReceivedDate', label: 'Amount Received Date' },
    { id: 'amntRemaining', label: 'Due Amount' },
    { id: 'amntRemainingDate', label: 'Amount Due Date' },
  ];

  public static UNITS = [
    '',
    'KG',
    'GM',
    'L',
    'ML',
    'Tes Spoon',
    'Bowl',
    'Piece',
    'Portion',
    'Dozen',
    'Tbsp',
    'Cup',
    'Slices',
    'Hours',
    'Minute',
    'Days',
    'Hour',
    'Minutes',
    'Day',
  ];

  public static FOOD_ITEMS = [
    'Chicken',
    'Mutton',
    'Fish',
    'Paneer',
    'Rice',
    'Poha',
    'Curd',
    'Milk',
    'Salad',
  ];
  public static CHOICES = [null, 'With', 'And', 'Or'];

  public static MEAL_PLAN_OPTIONS = [
    { id: 1, value: 'Early Morning Meal' },
    { id: 2, value: 'Breakfast' },
    { id: 3, value: 'Post Breakfast Meal' },
    { id: 4, value: 'Lunch' },
    { id: 5, value: 'Post Lunch' },
    { id: 6, value: 'Evening Snacks' },
    { id: 7, value: 'Pre Workout Meal' },
    { id: 8, value: 'Post Workout Meal' },
    { id: 9, value: 'Dinner' },
    { id: 10, value: 'Post Dinner' },
    { id: 10, value: 'Late Night Dinner' },
    { id: 11, value: 'Other Timing' },
  ];

  public static scheduleNewApt = (row: any) => {
    // const msg = new elementsConfig(true, 'Schedule Appointment');
    // const primaryBtn = new elementsConfig(true, 'Schedule');
    // const secondaryBtn = new elementsConfig(true, 'Cancel');
    // const input = [
    //   new inputConfig(
    //     InputType.ReadOnly,
    //     true,
    //     row.firstName + ' ' + row.lastName,
    //     false,
    //     true,
    //     new DropdownConfig([], '', ''),
    //     '',
    //     'Client Name'
    //   ),
    //   new inputConfig(
    //     InputType.ReadOnly,
    //     true,
    //     row.appointmentNo + 1 > 0 ? '20 Minutes' : '45 Minutes',
    //     false,
    //     true,
    //     new DropdownConfig([], '', ''),
    //     '',
    //     ' ( Appointment No: ' +
    //       Number(row.appointmentNo + 1) +
    //       ' ) ' +
    //       'Duration '
    //   ),
    //   new inputConfig(
    //     InputType.DatePicker,
    //     true,
    //     '',
    //     false,
    //     true,
    //     new DropdownConfig([], '', ''),
    //     '',
    //     'Appointment Date: '
    //   ),
    //   new inputConfig(
    //     InputType.TimePicker,
    //     true,
    //     '',
    //     false,
    //     true,
    //     new DropdownConfig([], '', ''),
    //     '',
    //     'Appointment Time: '
    //   ),
    // ];
    // return new DialogProperty(msg, primaryBtn, secondaryBtn, input);
    // this.getAptDetails(row, prop);
  };

  static rescheduleApt = (row: any, aptData: any) => {
    const msg = new elementsConfig(true, 'Re-Schedule Appointment');
    const primaryBtn = new elementsConfig(true, 'Re-Schedule');
    const secondaryBtn = new elementsConfig(true, 'Cancel');
    const input = [
      new inputConfig(
        InputType.ReadOnly,
        true,
        row.firstName + ' ' + row.lastName,
        false,
        true,
        new DropdownConfig([], '', ''),
        '',
        'Client Name'
      ),
      new inputConfig(
        InputType.ReadOnly,
        true,
        row.appointmentNo > 1 ? '20 Minutes' : '45 Minutes',
        false,
        true,
        new DropdownConfig([], '', ''),
        '',
        ' ( Appointment No: ' + Number(row.appointmentNo) + ' ) ' + 'Duration '
      ),
      new inputConfig(
        InputType.DatePicker,
        true,
        aptData.appotDate,
        false,
        true,
        new DropdownConfig([], '', ''),
        '',
        'Appointment Date: '
      ),
      new inputConfig(
        InputType.TimePicker,
        true,
        aptData.appotTime,
        false,
        true,
        new DropdownConfig([], '', ''),
        '',
        'Appointment Time: '
      ),
    ];
    return new DialogProperty(msg, primaryBtn, secondaryBtn, input);
    // this.getAptDetails(row, prop);
  };
}
